import { Environment } from './environment_type';

export const environment: Environment = {
	production: true,
	api_url: 'https://devzeegw.vemoit.com/fms/mex',
	gateway: 'https://devzeegw.vemoit.com',
	app_base_url: 'https://devfms.vemoit.com',
	environment: 'dev',
	tenants: ['mex', 'lto'],
	routes: {
		mex: 'https://devzeegw.vemoit.com/fms/mex',
		lto: 'https://devzeegw.vemoit.com/fms/lto',
	},
};
